import { getToken } from "utils/auth";
import { dev_baseUrl } from "utils/var";

export const GetOwner = async (navigate) => {

    const accesstoken = getToken();

    const owner = {
        "SearchTerm": "",
        "roleID": 2
    };

    if (accesstoken) {
        try {
            const response = await fetch(`${dev_baseUrl}/Employee/search`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accesstoken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(owner),
            });

            const data = await response.json();

            if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
                navigate(`/login`);
            } else {
                return data;
            }
        } catch (error) {
            console.error('Network error:', error);
            return [];
        }
    } else {
        console.warn('Access token is not available.');
        return { form: 'Access token is missing.' };
    }
};
